import { Routes, Route, Navigate } from "react-router-dom";
import React, { Component } from "react";
import { Signin, LogoutCallback, RedirectCallback } from "../Authentication/Callbacks";
import PrivateRoute from "../Shared/PrivateRoute";
import PageLoader from "../Shared/PageLoader";
import TopMenu from '../components/pages/Layout/TopMenu';
import ProjectListview from '../components/pages/Projects/ProjectListview';
import AddBI from "../components/pages/Projects/BasicInformation/AddBI";
import DeleteProject from "../components/pages/Projects/DeleteProject/DeleteProject";
import AddIC from "../components/pages/Projects/InCharge/AddIC";
import AddSP from "../components/pages/Projects/ShipParticulars/AddSP"
import AddINTRO from "../components/pages/Projects/Introduction/AddINTRO"
import AddPRO from "../components/pages/Projects/Process/AddPRO";
import AddHL from "../components/pages/Projects/HistoryLog/AddHL";
import ListViewOPA from '../components/pages/DailyTasks/OperationPlanningAchievements/ListViewOPA';
import EditOPA from '../components/pages/DailyTasks/OperationPlanningAchievements/EditOPA';
import SideBar from '../components/custom/sidebar';
import SidebarEditProject from '../components/custom/SidebarEditProject';
import SidebarReport from '../components/custom/SidebarReport';
import SidebarYardDocument from '../components/custom/SidebarYardDocument';
import SidebarAddProject from '../components/custom/SidebarAddProject';
import SidebarShipDocument from '../components/custom/SidebarShipDocument';
import ShipDocument from '../components/pages/ShipDocuments/ShipDocument';
import PreCuttingReport from '../components/pages/ReportManagement/PreCuttingReport';
import WeeklyReport from '../components/pages/ReportManagement/WeeklyReport';
import FinalReport from '../components/pages/ReportManagement/FinalReport';
import MonthlyReport from '../components/pages/ReportManagement/MonthlyReport';
import ShipUploadDocument from '../components/pages/ShipDocuments/UploadDocument';
import AddOPA from '../components/pages/DailyTasks/OperationPlanningAchievements/AddOPA';
import YardDocument from '../components/pages/YardDocuments/YardDocument';
import YardUploadDocument from '../components/pages/YardDocuments/UploadDocument';
import AuditReport from '../components/pages/AuditReport/AuditReport';
import AuditUploadDocument from '../components/pages/AuditReport/UploadDocument';
import CorrectiveAction from '../components/pages/CorrectiveAction/CorrectiveAction';
import CorrectiveActionUploadDoc from '../components/pages/CorrectiveAction/UploadDocument';
import ListViewPBD from "../components/pages/DailyTasks/PreBeachingDocuments/ListViewPBD";
import AddPBD from "../components/pages/DailyTasks/PreBeachingDocuments/AddPBD"
import EditPBD from "../components/pages/DailyTasks/PreBeachingDocuments/EditPBD"
import ListViewPCP from "../components/pages/DailyTasks/PreCuttingProgress/PCPList";
import AddPCP from "../components/pages/DailyTasks/PreCuttingProgress/AddPCP";
import EditPCP from "../components/pages/DailyTasks/PreCuttingProgress/EditPCP"
import ListviewDWPReport from "../components/pages/DailyTasks/DailyWorkProgressReport/ListviewDWPReport"
import AddDWPR from "../components/pages/DailyTasks/DailyWorkProgressReport/AddDWPR";
import EditDWPR from "../components/pages/DailyTasks/DailyWorkProgressReport/EditDWPR";
import ListViewWP from "../components/pages/DailyTasks/WorkPermits/ListViewWP"
import AddWP from "../components/pages/DailyTasks/WorkPermits/AddWP"
import EditWP from "../components/pages/DailyTasks/WorkPermits/EditWP"
import ListViewDMPS from "../components/pages/DailyTasks/DailyManPowerStatus/ListViewDMPS";
import AddDMPS from "../components/pages/DailyTasks/DailyManPowerStatus/AddDMPS";
import EditDMPS from "../components/pages/DailyTasks/DailyManPowerStatus/EditDMPS";
import ListViewIR from "../components/pages/DailyTasks/InvestigationReports/ListViewIR";
import AddIR from "../components/pages/DailyTasks/InvestigationReports/AddIR";
import EditIR from "../components/pages/DailyTasks/InvestigationReports/EditIR";
import ListViewSOC from "../components/pages/DailyTasks/StatementOfCompletion/ListViewSOC";
import EditSOC from "../components/pages/DailyTasks/StatementOfCompletion/EditSOC";
import ListViewTPOY from "../components/pages/DailyTasks/TrainingPlanOfYard/ListViewTPOY";
import EditTPOY from "../components/pages/DailyTasks/TrainingPlanOfYard/EditTPOY"
import ListViewYDP from "../components/pages/DailyTasks/YardDrillPlan/ListViewYDP";
import ListViewTM from "../components/pages/DailyTasks/TrainingModule/ListViewTM";
import EditYDP from "../components/pages/DailyTasks/YardDrillPlan/EditYDP";
import ListViewDISWC from "../components/pages/DailyTasks/DismantlingSequence/DismantlingWeightCalculation/ListViewDISWC";
import EditSD from "../components/pages/DailyTasks/DismantlingSequence/DismantlingPlan/SectionDivision/EditSD";
import AddSD from "../components/pages/DailyTasks/DismantlingSequence/DismantlingPlan/SectionDivision/AddSD";
import AddNewSD from "../components/pages/DailyTasks/DismantlingSequence/DismantlingPlan/SectionDivision/AddNewSD";
import EditDRAWSD from "../components/pages/DailyTasks/DismantlingSequence/DismantlingPlan/SectionDivision/EditDRAWSD";
import TabSD from "../components/pages/DailyTasks/DismantlingSequence/DismantlingPlan/SectionDivision/TabSD";
import ListViewBD from "../components/pages/DailyTasks/DismantlingSequence/DismantlingPlan/BlockDivision/ListViewBD";
import ListViewDISPRO from "../components/pages/DailyTasks/DismantlingSequence/DismantlingProgress/ListViewDISPRO";
import AddDISPRO from "../components/pages/DailyTasks/DismantlingSequence/DismantlingProgress/AddDISPRO";
import EditDISPRO from "../components/pages/DailyTasks/DismantlingSequence/DismantlingProgress/EditDISPRO";
import ListViewDROHM from "../components/pages/DailyTasks/DispositionRecordsOfHazardousMaterials/ListViewDROHM";
import AddDROHM from "../components/pages/DailyTasks/DispositionRecordsOfHazardousMaterials/AddDROHM";
import EditDROHM from "../components/pages/DailyTasks/DispositionRecordsOfHazardousMaterials/EditDROHM";
import ListViewMOM from "../components/pages/DailyTasks/MatrixOfMaterials/ListViewMOM";
import AddMOM from "../components/pages/DailyTasks/MatrixOfMaterials/AddMOM";
import EditMOM from "../components/pages/DailyTasks/MatrixOfMaterials/EditMOM";
import Dashboard from "../components/pages/ProjectDashboard/Dashboard"
import ListViewIADOS from "../components/pages/DailyTasks/InitialAuditDailyObservationStatus/ListViewIADOS";
import AddIADOS from "../components/pages/DailyTasks/InitialAuditDailyObservationStatus/AddIADOS";
import EditIADOS from "../components/pages/DailyTasks/InitialAuditDailyObservationStatus/EditIADOS";
import HSEQKPI from "../components/pages/DailyTasks/HSEQ/HSEQKPI/HSEQKPI"
import ListViewHSEQPerform from "../components/pages/DailyTasks/HSEQ/HSEQPerformance/ListViewHSEQPerform";
import AddHSEQPerform from "../components/pages/DailyTasks/HSEQ/HSEQPerformance/AddHSEQPerform";
import Settings from "../components/pages/Projects/Settings"
import PageNotFound from "../components/PageNotFound";
import UnautherizeContent from "../components/UnautherizeContent";
import UserExist from "../components/UserExist";
import axios from "axios";
import LViewDROHM from "../components/pages/MasterData/DROHM/LViewDROHM";
import AddEditDROHM from "../components/pages/MasterData/DROHM/AddEditDROHM";
import LViewMOM from "../components/pages/MasterData/MOM/LViewMOM";
import AddEditMOM from "../components/pages/MasterData/MOM/AddEditMOM";
import LViewDWP from "../components/pages/MasterData/DWP/LViewDWP";
import AddEditDWP from "../components/pages/MasterData/DWP/AddEditDWP";
import LViewOPA from "../components/pages/MasterData/OPA/LViewOPA";
import AddEditOPA from "../components/pages/MasterData/OPA/AddEditOPA";
import LViewPCP from "../components/pages/MasterData/PCP/LViewPCP";
import AddEditPCP from "../components/pages/MasterData/PCP/AddEditPCP";
import LViewIADOS from "../components/pages/MasterData/IADOS/LViewIADOS";
import AddEditIADOS from "../components/pages/MasterData/IADOS/AddEditIADOS";
import LViewStatus from "../components/pages/MasterData/Status/LViewStatus";
import AddEditStatus from "../components/pages/MasterData/Status/AddEditStatus";
import SidebarMasterData from "../components/custom/SidebarMasterData";
import ChangePassword from "../components/pages/Settings/ChangePassword";
import LViewAdmin from "../components/pages/UserManagement/Admin/LViewAdmin";
import AddEditAdmin from "../components/pages/UserManagement/Admin/AddEditAdmin";
import LViewShip from "../components/pages/UserManagement/ShipOwner/LViewShip";
import AddEditShip from "../components/pages/UserManagement/ShipOwner/AddEditShip";
import LViewYard from "../components/pages/UserManagement/YardOwner/LViewYard";
import AddEditYard from "../components/pages/UserManagement/YardOwner/AddEditYard";
import LViewSupervisior from "../components/pages/UserManagement/Supervisior/LViewSupervisor";
import AddEditSupervisior from "../components/pages/UserManagement/Supervisior/AddEditSupervisor";
import ShipMaster from "../components/pages/ProjectMasterData/ShipDocument/ShipMaster";
import YardMaster from "../components/pages/ProjectMasterData/YardDocument/YardMaster";
import PreBeachingMaster from "../components/pages/ProjectMasterData/PreBeaching/PreBeachingMaster"
import TrainingMaster from "../components/pages/ProjectMasterData/TrainingModule/TrainingMaster"
import StatementMaster from "../components/pages/ProjectMasterData/Statement/StatementMaster";
import SidebarUser from "../components/custom/SidebarUser";
import SidebarProjectMasterData from "../components/custom/SidebarProjectMasterData";
import GraphicalDashboard from "../components/pages/ProjectDashboard/GraphicalDashboard";
import LViewYardLookup from "../components/pages/MasterData/Yard/LViewYard";
import LViewRolesLookup from "../components/pages/MasterData/Roles/LViewRoles";
import LViewTrainingsLookup from "../components/pages/MasterData/Trainings/LViewTrainings";
import LViewCFP from "../components/pages/MasterData/CFP/LViewCFP";
import YardTrainingPlan from "../components/pages/YardTrainingPlan/YardTrainingPlan";
import YardTrainings from "../components/pages/YardTrainings/YardTrainings";
import YardRoles from "../components/pages/YardRoles/YardRoles";
import EditPlannedDate from "../components/pages/YardTrainingPlan/EditPlannedDate";
import EditActualDate from "../components/pages/YardTrainingPlan/EditActualDate";
import TrainingStatus from "../components/pages/DailyTasks/TrainingStatus/TrainingStatus";
import ViewActualDate from "../components/pages/DailyTasks/TrainingStatus/ViewActualDate";
import ListViewCFP from "../components/pages/DailyTasks/CarbonFootPrint/ListViewCFP";

class Routing extends Component {
  componentWillMount() {
    axios.interceptors.request.use(
      (config) => {
        const userDetails = localStorage.getItem("currentUser");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.accessToken;
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  }

  render() {
    return (
      <Routes>
        <Route exact path="/" element={<Navigate to={"/login"} />} />
        <Route exact path="/login" element={<Signin />} />
        <Route exact path="/signin" element={<RedirectCallback />} />
        <Route exact path="/logout" element={<LogoutCallback />} />
        <Route path="/unautherized" element={<UnautherizeContent />} />
        <Route path="/usernotfound" element={<UserExist />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="" element={<PrivateRoute><TopMenu /><PageLoader /></PrivateRoute>}>
          <Route path="projectlist" element={<ProjectListview />} />
          <Route path="basicinformation/add" element={<AddBI />} />
          <Route path="basicinformation/edit" element={<AddBI />} />
          <Route path="deleteproject/deleteproject" element={<DeleteProject />} />
          <Route path="incharge/add" element={<AddIC />} />
          <Route path="incharge/edit" element={<AddIC />} />
          <Route path="shipparticulars/add" element={<AddSP />} />
          <Route path="shipparticulars/edit" element={<AddSP />} />
          <Route path="introduction/add" element={<AddINTRO />} />
          <Route path="introduction/edit" element={<AddINTRO />} />
          <Route path="process/add" element={<AddPRO />} />
          <Route path="process/edit" element={<AddPRO />} />
          <Route path="settings/add" element={<Settings />} />
          <Route path="settings/edit" element={<Settings />} />
          <Route path="historylog" element={<AddHL />} />
          <Route path="dashboardold" element={<Dashboard />} />
          <Route path="shipdocument" element={<ShipDocument />} />
          <Route path="shipuploaddocument" element={<ShipUploadDocument />} />
          <Route path="yarduploaddocument" element={<YardUploadDocument />} />
          <Route path="yarddocument" element={<YardDocument />} />
          <Route path="auditreport" element={<AuditReport />} />
          <Route path="yard/roles" element={<YardRoles />} />
          <Route path="yard/trainings" element={<YardTrainings />} />
          <Route path="yard/trainingplan" element={<YardTrainingPlan />} />
          <Route path="audituploaddocument" element={<AuditUploadDocument />} />
          <Route path="correctiveaction" element={<CorrectiveAction />} />
          <Route path="correctiveactionuploaddoc" element={<CorrectiveActionUploadDoc />} />
          <Route path="sidebar" element={<SideBar />} />
          <Route path="sidebaryarddocument" element={<SidebarYardDocument />} />
          <Route path="sidebarshipdocument" element={<SidebarShipDocument />} />
          <Route path="sidebaraddproject" element={<SidebarAddProject />} />
          <Route path="sidebareditproject" element={<SidebarEditProject />} />
          <Route path="sidebarreport" element={<SidebarReport />} />
          <Route path="precuttingreport" element={<PreCuttingReport />} />
          <Route path="monthlyreport" element={<MonthlyReport />} />
          <Route path="weeklyreport" element={<WeeklyReport />} />
          <Route path="finalreport" element={<FinalReport />} />
          <Route path="operationplanningachievements" element={<ListViewOPA />} />
          <Route path="operationplanningachievements/addnew" element={<AddOPA />} />
          <Route path="operationplanningachievements/edit" element={<EditOPA />} />
          <Route path="operationplanningachievements/view" element={<EditOPA />} />
          <Route path="prebeachingdocuments" element={<ListViewPBD />} />
          <Route path="prebeachingdocuments/addnew" element={<AddPBD />} />
          <Route path="prebeachingdocuments/edit" element={<EditPBD />} />
          <Route path="prebeachingdocuments/view" element={<EditPBD />} />
          <Route path="precuttingprogressreport" element={<ListViewPCP />} />
          <Route path="precuttingprogressreport/addnew" element={<AddPCP />} />
          <Route path="precuttingprogressreport/edit" element={<EditPCP />} />
          <Route path="precuttingprogressreport/view" element={<EditPCP />} />
          <Route path="workpermits" element={<ListViewWP />} />
          <Route path="workpermits/addnew" element={<AddWP />} />
          <Route path="workpermits/edit" element={<EditWP />} />
          <Route path="workpermits/view" element={<EditWP />} />
          <Route path="trainingmodule" element={<ListViewTM />} />
          <Route path="trainingplanofyard" element={<ListViewTPOY />} />
          <Route path="trainingplanofyard/edit" element={<EditTPOY />} />
          <Route path="yarddrillplan" element={<ListViewYDP />} />
          <Route path="yarddrillplan/edit" element={<EditYDP />} />
          <Route path="yarddrillplan/view" element={<EditYDP />} />
          <Route path="dailyworkprogressreport" element={<ListviewDWPReport />} />
          <Route path="dailyworkprogressreport/addnew" element={<AddDWPR />} />
          <Route path="dailyworkprogressreport/edit" element={<EditDWPR />} />
          <Route path="dailyworkprogressreport/view" element={<EditDWPR />} />
          <Route path="dailymanpowerstatus" element={<ListViewDMPS />} />
          <Route path="dailymanpowerstatus/addnew" element={<AddDMPS />} />
          <Route path="dailymanpowerstatus/edit" element={<EditDMPS />} />
          <Route path="dailymanpowerstatus/view" element={<EditDMPS />} />
          <Route path="investigationreports" element={<ListViewIR />} />
          <Route path="investigationreports/addnew" element={<AddIR />} />
          <Route path="investigationreports/edit" element={<EditIR />} />
          <Route path="investigationreports/view" element={<EditIR />} />
          <Route path="hseq/kpi" element={<HSEQKPI />} />
          <Route path="hseq/Performance" element={<ListViewHSEQPerform />} />
          <Route path="hseq/performance/addnew" element={<AddHSEQPerform />} />
          <Route path="hseq/performance/edit" element={<AddHSEQPerform />} />
          <Route path="dismantlingplan/sectiondivision" element={<TabSD />} />
          <Route path="dismantlingplan/sectiondivision/addnew/0" element={<AddSD />} />
          <Route path="dismantlingplan/sectiondivision/addnew/1" element={<AddNewSD />} />
          <Route path="dismantlingplan/sectiondivision/edit/0" element={<EditDRAWSD />} />
          <Route path="dismantlingplan/sectiondivision/edit/1" element={<EditSD />} />
          <Route path="dismantlingplan/blockdivision" element={<ListViewBD />} />
          <Route path="dismantlingweightcalculation" element={<ListViewDISWC />} />
          <Route path="dismantlingprogress" element={<ListViewDISPRO />} />
          <Route path="dismantlingprogress/addnew" element={<AddDISPRO />} />
          <Route path="dismantlingprogress/edit" element={<EditDISPRO />} />
          <Route path="dismantlingprogress/view" element={<EditDISPRO />} />
          <Route path="initialauditdailyobservationstatus" element={<ListViewIADOS />} />
          <Route path="initialauditdailyobservationstatus/addnew" element={<AddIADOS />} />
          <Route path="initialauditdailyobservationstatus/edit" element={<EditIADOS />} />
          <Route path="initialauditdailyobservationstatus/view" element={<EditIADOS />} />
          <Route path="statementofcompletion" element={<ListViewSOC />} />
          <Route path="statementofcompletion/edit" element={<EditSOC />} />
          <Route path="statementofcompletion/view" element={<EditSOC />} />
          <Route path="dispositionrecordsofhazardousmaterials" element={<ListViewDROHM />} />
          <Route path="dispositionrecordsofhazardousmaterials/addnew" element={<AddDROHM />} />
          <Route path="dispositionrecordsofhazardousmaterials/edit" element={<EditDROHM />} />
          <Route path="dispositionrecordsofhazardousmaterials/view" element={<EditDROHM />} />
          <Route path="carbonfootprintghgreductioncalculation" element={<ListViewCFP />} />
          <Route path="matrixofmaterials" element={<ListViewMOM />} />
          <Route path="matrixofmaterials/addnew" element={<AddMOM />} />
          <Route path="matrixofmaterials/edit" element={<EditMOM />} />
          <Route path="matrixofmaterials/view" element={<EditMOM />} />
          <Route path="sidebarmasterdata" element={<SidebarMasterData />} />
          <Route path="masterdata/drohm" element={<LViewDROHM />} />
          <Route path="masterdata/drohm/add" element={<AddEditDROHM />} />
          <Route path="masterdata/drohm/edit" element={<AddEditDROHM />} />
          <Route path="masterdata/mom" element={<LViewMOM />} />
          <Route path="masterdata/mom/add" element={<AddEditMOM />} />
          <Route path="masterdata/mom/edit" element={<AddEditMOM />} />
          <Route path="lookupdata/dwp" element={<LViewDWP />} />
          <Route path="lookupdata/dwp/add" element={<AddEditDWP />} />
          <Route path="lookupdata/dwp/edit" element={<AddEditDWP />} />
          <Route path="lookupdata/opa" element={<LViewOPA />} />
          <Route path="lookupdata/opa/add" element={<AddEditOPA />} />
          <Route path="lookupdata/opa/edit" element={<AddEditOPA />} />
          <Route path="lookupdata/pcp" element={<LViewPCP />} />
          <Route path="lookupdata/pcp/add" element={<AddEditPCP />} />
          <Route path="lookupdata/pcp/edit" element={<AddEditPCP />} />
          <Route path="lookupdata/iados" element={<LViewIADOS />} />
          <Route path="lookupdata/iados/add" element={<AddEditIADOS />} />
          <Route path="lookupdata/iados/edit" element={<AddEditIADOS />} />
          <Route path="lookupdata/status" element={<LViewStatus />} />
          <Route path="lookupdata/status/add" element={<AddEditStatus />} />
          <Route path="lookupdata/status/edit" element={<AddEditStatus />} />
          <Route path="lookupdata/yard" element={<LViewYardLookup />} />
          <Route path="lookupdata/roles" element={<LViewRolesLookup />} />
          <Route path="lookupdata/trainings" element={<LViewTrainingsLookup />} />
          <Route path="lookupdata/cfp" element={<LViewCFP />} />
          <Route path="changepassword" element={<ChangePassword />} />
          <Route path="usermanagement/admin" element={<LViewAdmin />} />
          <Route path="usermanagement/admin/add" element={<AddEditAdmin />} />
          <Route path="usermanagement/admin/edit" element={<AddEditAdmin />} />
          <Route path="usermanagement/shipowner" element={<LViewShip />} />
          <Route path="usermanagement/shipowner/add" element={<AddEditShip />} />
          <Route path="usermanagement/shipowner/edit" element={<AddEditShip />} />
          <Route path="usermanagement/yardowner" element={<LViewYard />} /> 
          <Route path="usermanagement/yardowner/add" element={<AddEditYard />} />
          <Route path="usermanagement/yardowner/edit" element={<AddEditYard />} />
          <Route path="usermanagement/supervisior" element={<LViewSupervisior />} />
          <Route path="usermanagement/supervisior/add" element={<AddEditSupervisior />} />
          <Route path="usermanagement/supervisior/edit" element={<AddEditSupervisior />} />
          <Route path="projectmaster/shipdocument" element={<ShipMaster />} />
          <Route path="projectmaster/yarddocument" element={<YardMaster />} />
          <Route path="projectmaster/prebeachingdocument" element={<PreBeachingMaster />} />
          <Route path="projectmaster/trainingdocument" element={<TrainingMaster />} />
          <Route path="projectmaster/statementdocument" element={<StatementMaster />} />
          <Route path="sidebaruser" element={<SidebarUser />} />
          <Route path="sidebarprojectmasterdata" element={<SidebarProjectMasterData />} />
          <Route path="dashboard" element={<GraphicalDashboard />} />
          <Route path="yard/trainingplan/planneddate/:id" element={<EditPlannedDate />} />
          <Route path="yard/trainingplan/actualdate/:id" element={<EditActualDate />} />
          <Route path="trainingstatus" element={<TrainingStatus />} />
          <Route path="trainingstatus/viewactual" element={<ViewActualDate />} />
        </Route>
      </Routes>
    )
  }
}

export default Routing;
